(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dml-write-review"] && !Shopify.designMode) return;
  try {
    
  const sections = document.querySelectorAll('[data-section-id]');

  sections.forEach((section) => {
    const triggers = section.querySelectorAll('[aria-controls^="doom-modal-"]');
    const modal = section.querySelector('dialog');
    const close = section.querySelector('.write-review-modal-close');

    if (!triggers.length || !modal || !close) return;

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        modal.showModal();
        trigger.setAttribute('aria-expanded', 'true');
      });
    });

    close.addEventListener('click', () => {
      modal.close();
    });

    modal.addEventListener('close', () => {
      triggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });
    });

    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        modal.close();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["write-review"] && !Shopify.designMode) return;
  try {
    
  const sections = document.querySelectorAll('[data-section-id]');

  sections.forEach((section) => {
    const triggers = section.querySelectorAll('[aria-controls^="doom-modal-"]');
    const modal = section.querySelector('dialog');
    const close = section.querySelector('.write-review-modal-close');

    if (!triggers.length || !modal || !close) return;

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        modal.showModal();
        trigger.setAttribute('aria-expanded', 'true');
      });
    });

    close.addEventListener('click', () => {
      modal.close();
    });

    modal.addEventListener('close', () => {
      triggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });
    });

    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        modal.close();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
